import { render, staticRenderFns } from "./KdsTypeFilterBar.vue?vue&type=template&id=113d01b2&scoped=true"
import script from "./KdsTypeFilterBar.vue?vue&type=script&lang=js"
export * from "./KdsTypeFilterBar.vue?vue&type=script&lang=js"
import style0 from "./KdsTypeFilterBar.vue?vue&type=style&index=0&id=113d01b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d01b2",
  null
  
)

export default component.exports